import { render, staticRenderFns } from "./PaymentOptionHelp.vue?vue&type=template&id=54c3ecb4"
import script from "./PaymentOptionHelp.vue?vue&type=script&lang=js"
export * from "./PaymentOptionHelp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports